import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2c997f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-tips" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "输入验证码", -1))
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "input-wrap" }
const _hoisted_5 = { class: "input-content" }

import { computed, ref, onMounted, onUnmounted } from 'vue'
import AppHeader from '@/components/Header.vue'
import { Field, Button } from 'vant'
import { useStore } from 'vuex'
import { useRouter, Router } from 'vue-router'
import { useUsermobileInfo } from '@/compositions/common'
import { useSmsVerify } from '@/compositions/useSmsVerify'
import { sendSmsCode } from '@/apis/close-account'
import { isAndrod, isIos } from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'sms-verify',
  setup(__props) {

const store = useStore()
const $router: Router = useRouter()
const { formatUserMobileComputed, userMobileComputed } = useUsermobileInfo()
const { timeValue, hasSended, sendSmsMessage } = useSmsVerify<{ phone: string }>({
  timeTotal: 60,
  api: sendSmsCode,
})
const CloseAccountState = store.state.CloseAccount
const windHeight = window.innerHeight
const iosVsHeight = window?.visualViewport?.height
const vsH = ref(iosVsHeight)
const androidAdjustHeight = ref(12)
// const smsCode = ref(store.state?.CloseAccount?.code || '')
const btnText = computed(() => {
  if (!hasSended.value) {
    return '发送验证码'
  }
  if (timeValue.value) {
    return `重新发送（${timeValue.value}s）`
  }
  return '重新发送'
})
const sendBtnClass = computed(() => {
  if (timeValue.value) {
    return `resend-btn-class`
  }
  return 'pr4'
})

const footerStyle = computed(() => {
  if (isAndrod) {
    return {
      paddingBottom: `${androidAdjustHeight.value}px`,
    }
  } else if (isIos) {
    const baseStyle = {
      position: 'fixed',
      width: '100%',
      left: 0,
    }
    if (!iosVsHeight || iosVsHeight === vsH.value) {
      return {}
    }
    return {
      ...baseStyle,
      top: vsH.value - 72 + 'px',
    }
  }
  return {}
})
const canNext = computed(() => {
  const value = CloseAccountState.code
  return value.length === 6
})
function sendSmsMessageHandle() {
  sendSmsMessage({
    phone: userMobileComputed.value,
  })
}
function toConfirmClose() {
  $router.push({
    name: 'close-account-confirm',
  })
}
function androidKeybordHandle() {
  if (window.innerHeight < windHeight) {
    androidAdjustHeight.value = 48
  } else {
    androidAdjustHeight.value = 12
  }
}
function iosKeybordHandle() {
  if (!isIos) {
    return
  }
  vsH.value = window.visualViewport.height
}
onMounted(() => {
  if (isAndrod) {
    window.addEventListener('resize', androidKeybordHandle)
  }
})
onUnmounted(() => {
  if (isAndrod) {
    window.removeEventListener('resize', androidKeybordHandle)
  }
  window.visualViewport.removeEventListener('resize', iosKeybordHandle)
})
window.visualViewport.addEventListener('resize', iosKeybordHandle)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "注销账号" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, "发送短信至当前手机号" + _toDisplayString(_unref(formatUserMobileComputed)) + "，以验证身份", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Field), {
          placeholder: "请输入短信验证码",
          modelValue: _unref(CloseAccountState).code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(CloseAccountState).code) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", {
          class: _normalizeClass(["send-btn", _unref(sendBtnClass)]),
          onClick: sendSmsMessageHandle
        }, _toDisplayString(_unref(btnText)), 3)
      ])
    ]),
    _createElementVNode("div", {
      class: "footer xag-page__footer nongfu-button-wrap",
      style: _normalizeStyle(_unref(footerStyle))
    }, [
      _createVNode(_unref(Button), {
        type: "success",
        onClick: toConfirmClose,
        block: "",
        class: "button xa-vant-button",
        round: "",
        disabled: !_unref(canNext)
      }, {
        default: _withCtx(() => [
          _createTextVNode("下一步")
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 4)
  ], 64))
}
}

})